<template>
  <div class="register-page">
    <v-row no-gutters>
      <!-- form -->
      <v-col cols="10" md="12" sm="12" class="mt-1 mx-auto">
        <!-- sign in with -->
        <!-- <v-col cols="12" md="12" sm="4" align="center">
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-google</v-icon>
          </v-btn>
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-facebook</v-icon>
          </v-btn>
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-linkedin</v-icon>
          </v-btn>
        </v-col> -->
        <!-- sign in with ends -->
        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/fantasy_lineups_logo.png"
            width="360"
            class="mx-auto"
          />
        </v-col>

        <v-card
          class="ma-6 pa-3 mx-auto"
          shaped
          elevation="3"
          ripple
          raised
          color="#F5F5F5"
          max-width="500"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="register"
          >
            <div align="center" class="mt-n5">
              <v-col cols="12" md="12" sm="12" align="center">
                <p class="text-h5 green--text font-weight-bold">
                  Create Account
                </p>
                <small class="body-1">Use your E-mail for registration.</small>
              </v-col>

              <!-- //* username -->
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model="form.userName"
                  :counter="10"
                  :rules="nameRules"
                  label="Name*"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-account-circle-outline"
                ></v-text-field
              ></v-col>
            </div>

            <!-- //* email -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model.trim="form.email"
                  :rules="emailRules"
                  label="E-mail*"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-email-variant"
                ></v-text-field
              ></v-col>
            </div>

            <!-- //* password -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="12">
                <v-text-field
                  class="input"
                  v-model="form.password"
                  :rules="passwordRules"
                  label="Password*"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  outlined
                  filled
                  required
                  prepend-inner-icon="mdi-form-textbox-password"
                ></v-text-field
              ></v-col>

              <!-- //* button -->
              <v-col cols="12" md="8" sm="12" class="mt-n5">
                <!-- <v-checkbox
                  v-model="checkbox"
                  :rules="[(v) => !!v || 'You must agree to continue!']"
                  label="Do you agree?"
                  required
                ></v-checkbox> -->
                <v-btn block color="#00C853" type="submit" class="mr-4">
                  <v-progress-circular
                    v-if="getTeamLoader"
                    indeterminate
                    :width="5"
                    color="primary"
                  ></v-progress-circular>
                  Sign Up
                </v-btn>
              </v-col>
            </div>
            <v-col cols="12" md="12" align="center">
              <small class="body-2">
                Already have account?
                <router-link to="/login" color="blue">Login</router-link>
              </small>
            </v-col>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "ClickSignUpForm",
  title: "Fantasylinesups.com Registration",

  data: () => ({
    valid: true,
    showPassword: false,
    snackbar: false,
    text: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 20) || "Name must be less than 10 characters",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [
      (v) =>
        (v && /^[a-z0-9\-]+$/.test(v)) ||
        `Only lowercase letters, numbers or hyphens allowed`,
      (v) => v.length >= 6 || "Min 6 characters",
    ],
    // select: null,
    // items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,

    form: {
      email: "",
      password: "",
      userName: "",
    },
  }),

  computed: {
    ...mapGetters("NbaModule", ["getTeamLoader"]),
    ...mapState("NbaModule", ["customerSession"]),
  },

  // beforeRouteEnter(to, from, next) {
  //   if (!to.params.price_id) {
  //     next({ name: 'Pricing' });
  //   } else {
  //     next();
  //   }
  // },

  mounted() {
    this.GoogleAnalytic();
    this.GoogleAds();
  },

  methods: {
    GoogleAnalytic() {
      this.$gtag.config("UA-204063830-2");
      this.$gtag.pageview({ page_path: "/sign-up" });
    },

    GoogleAds() {
      this.$gtag.config("AW-323506423");
    },

    register() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        // if (!localStorage.getItem('stripe_customer_id')) {
        this.$store
          .dispatch("NbaModule/userRegister", {
            userName: this.form.userName,
            email: this.form.email,
            password: this.form.password,
            paymentType: "clickbank",
          })
          .then(() => {
            if (this.$store.state.NbaModule.user == null) {
              alert("email/username already exist please go to login page.");
            } else {
              window.location.href = `https://dfslineups.pay.clickbank.net/?cbitems=1&cbskin=18731&email=${this.form.email}`;
            }
          });
        // }
        //  else {
        //   alert(
        //     "You've got registerd, now go to the pricing section and select your plan.."
        //   );
        // }
      }
    },

    ProceedPayment(priceId) {
      let obj = {
        stripe_customer_id: localStorage.getItem("stripe_customer_id"),
        price_id: priceId,
      };
      this.$store.dispatch("NbaModule/createSession", obj).then(() => {
        let path = this.customerSession.session["url"];

        location.href = path;
        //console.log(this.customerSession);
      });
    },
  },
};
</script>

<style scoped>
.register-page {
  background-color: #212121;
  height: 100%;
}

.input >>> input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0px;
}
</style>
